/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TestCaseVisibility = {
    Example: 'example',
    Public: 'public',
    Private: 'private'
} as const;
export type TestCaseVisibility = typeof TestCaseVisibility[keyof typeof TestCaseVisibility];


export function instanceOfTestCaseVisibility(value: any): boolean {
    for (const key in TestCaseVisibility) {
        if (Object.prototype.hasOwnProperty.call(TestCaseVisibility, key)) {
            if (TestCaseVisibility[key as keyof typeof TestCaseVisibility] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TestCaseVisibilityFromJSON(json: any): TestCaseVisibility {
    return TestCaseVisibilityFromJSONTyped(json, false);
}

export function TestCaseVisibilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestCaseVisibility {
    return json as TestCaseVisibility;
}

export function TestCaseVisibilityToJSON(value?: TestCaseVisibility | null): any {
    return value as any;
}

export function TestCaseVisibilityToJSONTyped(value: any, ignoreDiscriminator: boolean): TestCaseVisibility {
    return value as TestCaseVisibility;
}

